// @ts-nocheck
import { inputStyles } from "@store/Themes/common/mixins/formField";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/FormField ------------------------------------ */
/* ------------------------------------------------------------------------------------------ */

const formField: Styleguide["formField"] = {
    defaultProps: {
        border: "rounded",

        labelProps: {
            css: css`
                ${({ theme }) => css`
                    font-weight: ${theme.design.typography.weight.bold};
                    line-height: ${theme.design.typography.lineHeight.semi};
                    margin-bottom: ${pxToRem(4)};
                `}
            `,
        },
        errorProps: {
            color: "danger",
            size: "inherit",
            weight: "inherit",
        },
        hintProps: {
            color: "info",
            size: "inherit",
            weight: "inherit",
        },
        cssOverrides: {
            formField: css`
                textarea {
                    ${inputStyles()}
                }
            `,
            inputSelect: css`
                ${inputStyles()}
            `,
            descriptionWrapper: css`
                ${({ theme }) => css`
                    font-weight: ${theme.design.typography.weight.bold};
                    line-height: ${theme.design.typography.lineHeight.small};
                `}
            `,
        },
    },
};

export default formField;
